var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "searchable-demo-file-list" },
    _vm._l(_vm.files, function(file) {
      return _c(
        "div",
        {
          key: file.path,
          staticClass: "searchable-demo-file-list__node",
          class: {
            "searchable-demo-file-list__node--pre-selected": _vm.filePreSelected(
              file
            )
          },
          on: {
            click: function($event) {
              _vm.$emit("selected")
            }
          }
        },
        [_c("book-component-list-item", { attrs: { file: file } })],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }